import React, { useState } from 'react';
import CustomDateInput from '../../../customComponents/CustomDateInput';
import SearchableDropdown from '../../../customComponents/CustomSearchableDropdown';

const ListFilters = ({ handleSearch=()=>{}, clearSearch=()=>{}, city, make , model, product , isPresales,productdd, setProductdd, makedd, setMakedd}) => {
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [ modeldd, setModeldd ] = useState([])
 
  const onSearchClick = () => {
    const filters = {
      fromDate: fromDate ? fromDate.toISOString().split('T')[0] : null,
      toDate: toDate ? toDate.toISOString().split('T')[0] : null,
      city: selectedOption ? selectedOption.value : null,
      // make: makedd ? makedd.value : null,
      // product: productdd ? productdd.value : null,
      // model: modeldd ? modeldd.value : null
    };

    if (filters.fromDate || filters.toDate || filters.city 
      // || filters.make || filters.product || filters.model
    ) {
      handleSearch(filters);
    } else {
      console.log('No filters applied, search not triggered.');
    }
  };

  const onClearClick = () => {
    setFromDate(null);
    setToDate(null);
    setSelectedOption(null);
    // setMakedd({});
    // setModeldd({});
    // setProductdd({});
    clearSearch();
  };

  return (
    <div className='filterContainer'>
      {isPresales ? (
        <>
        {/* <CustomDateInput label={"From Date"} value={fromDate} onChange={setFromDate} />
        <CustomDateInput label={"To Date"} value={toDate} onChange={setToDate} /> */}
          <SearchableDropdown
            label="Product"
            options={product}
            value={productdd}
            onChange={setProductdd}
            placeholder="Product"
          />
          <SearchableDropdown
            label="Make"
            options={make}
            value={makedd}
            onChange={setMakedd}
            placeholder="Make"
          />
          <SearchableDropdown
            label="Model"
            options={model}
            value={modeldd}
            onChange={setModeldd}
            placeholder="Model"
          />
        </>
      ) : (
        <>
          <CustomDateInput label={"From Date"} value={fromDate} onChange={setFromDate} />
          <CustomDateInput label={"To Date"} value={toDate} onChange={setToDate} />
          {/* <SearchableDropdown
            label="City"
            options={city}
            value={selectedOption}
            onChange={setSelectedOption}
            placeholder="Select City"
          /> */}
        </>
      )}
      <div className='fltr-btns-container'>
        <button className='flte-btn' onClick={onSearchClick}>Search</button>
        <button className='clear-btn' onClick={onClearClick}>Clear</button>
      </div>
    </div>

  );
};

export default ListFilters;
